export default __webpack_public_path__ + "static/media/notfound.3d04f1e5.svg";